export default "/images/45fb4ef14f4f22d24d9a2dc80ab26404.avif";